<template>
  <div
    class="w3-sidebar w3-collapse w3-white w3-bar-block w3-card w3-animate-left"
    style="z-index: 1; width: 300px"
    id="mySidebar"
  >
    <button class="w3-bar-item w3-button w3-large w3-hide-large" @click="w3_close()">Close &times;</button>
    <br />
    <div class="w3-container">
      <a href="https://ep-ese.web.cern.ch"
        ><img
          src="@/assets/images/logo.png"
          style="width: 30%"
          class="w3-round" /></a
      ><br /><br />
    </div>
    <template v-if="!userSections">
      <div class="w3-container">
        <h5><b>Documentation</b></h5>
      </div>

      <div>
        <template v-for="route in routes" v-bind:key="route">
          <a
            class="w3-bar-item w3-button w3-padding w3-active"
            :href="route.path"
            ><i class="fas fa-fw w3-margin-right"></i>{{ route.name }}</a
          >
        </template>
      </div>
    </template>
    <template v-else>
      <template v-for="section in sectionRoutes" v-bind:key="section">
        <div class="w3-container">
          <h5>
            <b
              ><a
                style="color: inherit; text-decoration: inherit"
                :href="section.path"
                >{{ section.name }}</a
              ></b
            >
          </h5>
        </div>
        <template
          v-for="route in subsectionRoutes[section.path.substring(1)]"
          v-bind:key="route"
        >
          <a
            class="w3-bar-item w3-button w3-padding w3-active"
            :href="route.path"
            ><i class="fas w3-margin-right" :class="route.meta.icon"></i
            >{{ route.name }}</a
          >
        </template>
      </template>
      <template v-for="route in routes" v-bind:key="route">
        <template
          v-if="
            !route.path.substring(1).includes('/') &&
            !sectionRoutes.some((r) => r.name == route.name)
          "
        >
          <h6>
            <a
              class="w3-bar-item w3-button w3-padding w3-active"
              :href="route.path"
              ><i class="fas w3-margin-right"></i> <b> {{ route.name }} </b></a
            >
          </h6>
        </template>
      </template>
    </template>

    <div class="w3-container">
      <h5>
        <b
          ><a
            style="color: inherit; text-decoration: inherit"
            href="/distribution"
            >Distribution</a
          ></b
        >
      </h5>
    </div>

    <div class="w3-bar-block">
      <a
        class="w3-bar-item w3-button w3-padding w3-active"
        href="/distribution/order"
        ><i class="fas fa-shopping-cart w3-margin-right"></i> Order parts</a
      >
      <a
        class="w3-bar-item w3-button w3-padding w3-active"
        href="/distribution/myorders"
        ><i class="fas fa-list w3-margin-right"></i> My Orders
      </a>
      <!-- </div> -->
    </div>

    <div class="w3-container">
      <h5>
        <b
          ><a style="color: inherit; text-decoration: inherit" href="/account"
            >User</a
          ></b
        >
      </h5>
    </div>

    <div class="w3-bar-block">
      <a class="w3-bar-item w3-button w3-padding w3-active" @click="logout()"
        ><i class="fas fa-sign-out-alt w3-margin-right"></i> Sign-Out</a
      >
    </div>
      <div class="w3-container">
      <h5>
        <b
          ><a style="color: inherit; text-decoration: inherit" href="/contact"
            >Contact</a
          ></b
        >
      </h5>
    </div>
    <br />
    <Basket></Basket>
  </div>

  <div class="w3-main main-content">
    <button class="w3-button w3-teal w3-xlarge w3-hide-large" @click="w3_open()">&#9776;</button>
    <router-view></router-view>
  </div>
</template>

<style scoped src="./assets/styles.css">
</style>

<script>
import Basket from "./components/Basket.vue";
import UserPage from "@/components/UserPage";
import UserSectionSummaryPageVue from "./components/UserSectionSummaryPage.vue";

export default {
  components: {
    Basket,
  },
  data() {
    return {
      userDetails: null,
      loginurl: "",
      logouturl: "",
      routes: [],
      userSections: false,
      sectionRoutes: [],
      subsectionRoutes: {},
    };
  },
  methods: {
    login: function () {
      const app = this;
      fetch(
        process.env.VUE_APP_URL +
          "/restapi/user/get_connection_info?r=" +
          window.location.href,
        {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          app.logouturl = json["disconnect_url"];
          app.loginurl = json["connect_url"];

          $("#loading-node").remove();

          if (json["connected"] == false) {
            window.location.replace(app.loginurl);
          } else {
            app.userDetails = json["user"];
            console.log("userDetails", app.userDetails);
            app.$store.dispatch("setUserDetails", app.userDetails);
          }
        });
    },
    w3_open: function() {
      document.getElementById("mySidebar").style.display = "block";
    },
    w3_close: function() {
      document.getElementById("mySidebar").style.display = "none";
    },
    logout: function () {
      window.location.replace(this.logouturl);
    },
  },

    async created() {
      this.login();
      // routes
      console.log("Routes of the router", this.$router.getRoutes())
      var routes = this.$router.getRoutes()
      var index = routes.findIndex(r => r.path == '/account')
      routes.splice(index, 1);
      index = routes.findIndex(r => r.path == '/distribution/order');
      routes.splice(index, 1);
      index = routes.findIndex(r => r.path == '/distribution/orderdetails');
      routes.splice(index, 1);
      var index = routes.findIndex(r => r.path == '/distribution')
      routes.splice(index, 1);
      var index = routes.findIndex(r => r.path == '/distribution/myorders')
      routes.splice(index, 1);
      index = routes.findIndex(r => r.path == '/distribution/myorders/:id');
      routes.splice(index, 1);
      console.log(routes)
      this.routes = routes;

      // userSections
      this.userSections = this.routes.some( r => r.path.substring(1).includes('/'))

      // sectionRoutes
      this.sectionRoutes = this.routes.filter( r => r.components.default.name == "UserSectionSummaryPage" );
      console.log(this.sectionRoutes)

      var i;
      for (i = 0; i < this.sectionRoutes.length; i++) {
        var route = this.sectionRoutes[i]
        if ( route.path != '/' )
        this.subsectionRoutes[route.path.substring(1)] = this.routes.filter( r => r.path.includes(route.path) && r.path != route.path );
      }
      
      console.log(this.subsectionRoutes)

    }
};
</script>
